import {Component} from '@angular/core';


@Component({
    selector: 'app-repository-policy-documents-aside',
    templateUrl: './repository-policy-documents-aside.component.html',
})

export class RepositoryPolicyDocumentsAsideComponent {
}
